export default __webpack_public_path__ + "static/media/gallery-wip-handle_00.ba58ce09.jpg";